import { render, staticRenderFns } from "./AcighModal.vue?vue&type=template&id=28fe27c8&"
import script from "./AcighModal.vue?vue&type=script&lang=js&"
export * from "./AcighModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports